import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './app-layout/App';
import reportWebVitals from './util/reportWebVitals';
import {GoogleOAuthProvider} from '@react-oauth/google';
import config from "./util/Config";

const root = createRoot(
  document.getElementById('root') as HTMLElement
);

config.then(config =>
    root.render(
        <React.StrictMode>
            <GoogleOAuthProvider clientId={config.googleClientID}>
                <App />
            </GoogleOAuthProvider>
        </React.StrictMode>
    )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
